"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var semantic_ui_react_1 = require("semantic-ui-react");
var lodash_1 = require("lodash");
var filters_1 = require("../../../../helpers/filters");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var DistrictsList = function (_a) {
    var districts = _a.districts, states = _a.states, onSelect = _a.onSelect, selectedDistricts = _a.selectedDistricts, searchValue = _a.searchValue, currentLanguage = _a.currentLanguage;
    var _b = react_1.useState(), modifiedDistricts = _b[0], setModifiedDistricts = _b[1];
    react_1.useEffect(function () {
        if (districts.length) {
            var filteredData = filters_1.groupByDistrictsByState(districts);
            setModifiedDistricts(filteredData);
        }
        else {
            setModifiedDistricts(districts);
        }
    }, [districts]);
    var toggleSelect = function (govId) {
        onSelect(govId);
    };
    var renderHTMLLabel = function (label) {
        var searchLetters = label.slice(0, searchValue.length);
        var nonSearchLetters = label.slice(searchValue.length);
        return (react_1.default.createElement("label", null,
            react_1.default.createElement("strong", null, searchLetters),
            nonSearchLetters));
    };
    var renderLists = function () {
        return !lodash_1.isUndefined(modifiedDistricts) &&
            Object.keys(modifiedDistricts).map(function (district) { return (react_1.default.createElement("div", { key: district, className: "state-group" },
                react_1.default.createElement("h4", null, filters_1.getStateNameById(district, states, currentLanguage)),
                react_1.default.createElement("ul", { role: "listBox", className: "choices" }, Object.keys(modifiedDistricts[district]).map(function (districtId) {
                    var _a;
                    return (react_1.default.createElement("li", { role: "listBox", key: districtId, className: styles_module_scss_1.default.list_item },
                        react_1.default.createElement(semantic_ui_react_1.Checkbox, { checked: selectedDistricts.includes(String(modifiedDistricts[district][districtId].govId)), onChange: function () {
                                return toggleSelect(modifiedDistricts[district][districtId].govId);
                            }, label: renderHTMLLabel(modifiedDistricts[district][districtId]
                                .translations
                                ? (_a = modifiedDistricts[district][districtId].translations[currentLanguage]) !== null && _a !== void 0 ? _a : modifiedDistricts[district][districtId].text
                                : modifiedDistricts[district][districtId].text) })));
                })))); });
    };
    return react_1.default.createElement(react_1.default.Fragment, null, districts.length ? renderLists() : null);
};
exports.default = DistrictsList;
